import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { BetDataJantri } from '../Api/BetDataJantri';
import { CuttingDataJantri } from '../Api/CuttingDataJantri';

export default function NumberCut() {
    const { sessionDetail, setWallet, setLoad, setLoadColor } = useContext(Context);
    const auth_token = JSON.parse(localStorage.getItem('userinfo'))?.auth_token;

    const [numberData, setNumberData] = useState([]);
    const [isClient, setIsClient] = useState(null);
    const [isGames, setIsGames] = useState(null);
    const [jodiTotal, setJodiTotal] = useState(0);
    const [haroofTotal, setHaroofTotal] = useState(0);
    const [finalTotal, setFinalTotal] = useState(0);
    const [harufAndar, setHarufAndar] = useState([])
    const [harufBahar, setHarufBahar] = useState([]);

    const [cutNum, setCutNum] = useState('');
    const [cutHrf, setCutHrf] = useState('');
    const [cuttingJodiText, setCuttingJodiText] = useState('');
    const [cuttingHaroofTextAndar, setCuttingHaroofTextAndar] = useState('');
    const [cuttingHaroofTextBahar, setCuttingHaroofTextBahar] = useState('');
    const [copiedJodi, setCopiedJodi] = useState(false);
    const [copiedHaroofAndar, setCopiedHaroofAndar] = useState(false);
    const [copiedHaroofBahar, setCopiedHaroofBahar] = useState(false);

    useEffect(() => {
        if (auth_token && Object.keys(sessionDetail).length > 0) {
            setNumberData(sessionDetail?.bet_numbers);
        }
    }, [sessionDetail, auth_token]);

    const handleClientChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsClient(value);
    };

    const handleGameChange = (e) => {
        const value = e.target.value === '' ? null : e.target.value;
        setIsGames(value);
    };

    const handleDoneClick = async () => {
        if (!isClient || !isGames) {
            toast.warn("Please select both client and game!", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
            return;
        }

        if (!cutNum && !cutHrf) {
            toast.warn("Please enter Cutting Number or Haroof Rs.", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
            return;
        }

        const userInfo = JSON.parse(localStorage.getItem('userinfo'));
        let data = {
            client_name: isClient,
            game_name: isGames,
            username: userInfo?.username,
            user_id: userInfo?.userId,
            cutNum: Number(cutNum),
            cutHrf: Number(cutHrf)
        };

        setLoad(true);
        setLoadColor("#ff4364");

        try {
            const res = await CuttingDataJantri(data);

            if (res?.data?.status) {
                setCuttingJodiText(res.data.cuttingJodi || "");
                setCuttingHaroofTextAndar(res.data.cuttingHaroof.andar || ""); // placeholder for haroof if needed
                setCuttingHaroofTextBahar(res.data.cuttingHaroof.bahar || ""); // placeholder for haroof if needed
            } else {
                setCuttingJodiText("no data above cutNum");
                setCuttingHaroofTextAndar("no data above cutHrf");
                setCuttingHaroofTextBahar("no data above cutHrf");
            }
        } catch (err) {
            setCuttingJodiText("no data above cutNum");
            setCuttingHaroofTextAndar("no data above cutHrf");
            setCuttingHaroofTextBahar("no data above cutHrf");
            toast.error("Something went wrong!", {
                position: "top-right",
                autoClose: 1500,
                theme: "colored",
                transition: Flip,
            });
        }

        setLoad(false);
    };
    const handleCopyJodi = () => {
        navigator.clipboard.writeText(cuttingJodiText);
        setCopiedJodi(true);
        setTimeout(() => setCopiedJodi(false), 2000); // 2 seconds
    };

    const handleCopyHaroofAndar = () => {
        navigator.clipboard.writeText(cuttingHaroofTextAndar);
        setCopiedHaroofAndar(true);
        setTimeout(() => setCopiedHaroofAndar(false), 2000);
    };
    const handleCopyHaroofBahar = () => {
        navigator.clipboard.writeText(cuttingHaroofTextBahar);
        setCopiedHaroofBahar(true);
        setTimeout(() => setCopiedHaroofBahar(false), 2000);
    };

    useEffect(() => {
        (async () => {
            if (isClient && isGames) {
                const userInfo = JSON.parse(localStorage.getItem('userinfo'));

                let data = {
                    client_name: isClient,
                    game_name: isGames,
                    username: userInfo?.username,
                    user_id: userInfo?.userId
                };

                setLoad(true);
                setLoadColor("#ff4364");
                let res = await BetDataJantri(data);

                if (res) {
                    if (res.data.status) {
                        const updatedBet = res.data.updatedBetNumbers;
                        const sortedData = updatedBet.details.sort((a, b) => {
                            const keyA = Object.keys(a)[0];
                            const keyB = Object.keys(b)[0];
                            return parseInt(keyA, 10) - parseInt(keyB, 10);
                        });

                        setNumberData(sortedData);
                        const HarufBetNumbersAndr = res.data?.HarufBetNumbers?.andar || [];
                        // const highlightedNumbers = HarufBetNumbersAndr.map(obj => Number(Object.keys(obj)[0]));
                        console.log("highlightedNumbers ---> ", HarufBetNumbersAndr);
                        setHarufAndar(HarufBetNumbersAndr);

                        let HarufBetNumbersBhar = res.data?.HarufBetNumbers?.bahar || []
                        // HarufBetNumbersBhar = HarufBetNumbersBhar.map(obj => Number(Object.keys(obj)[0]));
                        console.log("HarufBetNumbersBhar ---> ", HarufBetNumbersBhar);
                        setHarufBahar(HarufBetNumbersBhar);

                        setWallet(updatedBet.total_amount);
                        setJodiTotal(updatedBet.jodi_total || 0);
                        setHaroofTotal(updatedBet.haroof_total || 0);
                        setFinalTotal(updatedBet.total_amount || 0);
                    } else {
                        setNumberData(sessionDetail?.bet_numbers);
                        setWallet(0);
                        setJodiTotal(0);
                        setHaroofTotal(0);
                        setFinalTotal(0);
                        toast.error(res.data.message, {
                            position: "top-right",
                            autoClose: 1500,
                            theme: "colored",
                            transition: Flip,
                        });
                    }
                }

                setLoad(false);
            } else {
                setNumberData(sessionDetail?.bet_numbers);
                setWallet(0);
                setJodiTotal(0);
                setHaroofTotal(0);
                setFinalTotal(0);
            }
        })();
    }, [isClient, isGames, sessionDetail?.bet_numbers, setLoad, setLoadColor, setWallet]);

    return (
        <>
            <div className='WholeNumberComponent'>
                <div className='container-Section'>
                    <div className="select-section">
                        <select className="select-dropdown" onChange={handleClientChange}>
                            <option value=''>Selects Client</option>
                            <option value='All Clients'>All Clients</option>
                            {sessionDetail?.user_clients?.map((client, index) => (
                                <option key={index} value={client}>{client}</option>
                            ))}
                        </select>
                        <select className="select-dropdown" onChange={handleGameChange}>
                            <option value=''>Select Games</option>
                            {sessionDetail?.user_games?.map((games, index) => (
                                <option key={index} value={games}>{games}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className='enter-Section'>
                    <div className="enter-section">
                        <input
                            type="number"
                            className="enter-dropdown"
                            placeholder="Cutting Number Rs."
                            value={cutNum}
                            onChange={(e) => setCutNum(e.target.value)}
                        />
                        <input
                            type="number"
                            className="enter-dropdown"
                            placeholder="Cutting Haruf Rs."
                            value={cutHrf}
                            onChange={(e) => setCutHrf(e.target.value)}
                        />
                        <button className="done-button" onClick={handleDoneClick}>Done</button>
                    </div>
                </div>

                <div className="numbers-grid">
                    {numberData?.map((ele, i) => {
                        let label, value;
                        if (typeof ele === 'object' && ele !== null) {
                            label = Object.keys(ele)[0];
                            value = ele[label];
                        } else {
                            const num = ele - 1 < 10 ? `0${ele - 1}` : `${ele - 1}`;
                            label = num;
                            value = null;
                        }

                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{label}</div>
                                <div className="number-box">{(value === null || value === 0) ? "" : value}</div>
                            </div>
                        )
                    })}
                </div>

                <div className="color-row">
                    <div className="color-label">A. H.</div>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((ele, i) => {
                        console.log("ele --> --> ", ele);
                        const highlightedObj = harufAndar.find(obj => obj[ele] !== undefined); // Find the object with the matching key
                        const isHighlighted = highlightedObj !== undefined; // Check if the object exists
                        const value = isHighlighted ? highlightedObj[ele] : ''; // Extract the value if highlighted
                        console.log("isHighlighted0 --> --> ", isHighlighted, "value --> --> ", value);
                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{ele}</div>
                                <div className={`number-box ${isHighlighted ? 'highlighted' : ''}`}>
                                    {value} {/* Show the value if highlighted */}
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="color-row">
                    <div className="color-label">B. H.</div>
                    {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((ele, i) => {
                        console.log("ele --> --> ", ele);
                        const highlightedObj = harufBahar.find(obj => obj[ele] !== undefined); // Find the object with the matching key
                        const isHighlighted = highlightedObj !== undefined; // Check if the object exists
                        const value = isHighlighted ? highlightedObj[ele] : ''; // Extract the value if highlighted
                        console.log("isHighlighted1 --> --> ", isHighlighted, "value --> --> ", value);
                        return (
                            <div className="number-item" key={i}>
                                <div className="number-label">{ele}</div>
                                <div className={`number-box ${isHighlighted ? 'highlighted' : ''}`}>
                                    {value} {/* Show the value if highlighted */}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <div className="main-container1">
                <div className='total-values'>
                    <div className='joditotal'>
                        Jodi Total: <span className="blue-text">{jodiTotal} ₹</span>
                    </div>
                    <div className='joditotal'>
                        Haroof Total: <span className="blue-text">{haroofTotal} ₹</span>
                    </div>
                    <div className='joditotal'>
                        Final Total: <span className="blue-text">{finalTotal} ₹</span>
                    </div>
                </div>

                <div className='total-values'>
                    {/* <div className='cutting-jodi'>
                        {cuttingJodiText && cuttingJodiText !== "no data above cutNum" ? (
                            <>
                                <div className="text-line">Above {cutNum} Cutting Jodi:</div>
                                <div className="blue-text" style={{ marginTop: "5px" }}>{cuttingJodiText}</div>
                                <button
                                    onClick={handleCopyJodi}
                                    className="copy-button"
                                    style={{ marginTop: "8px" }}
                                >
                                    {copiedJodi ? "Copied!" : "Copy"}
                                </button>
                            </>
                        ) : (
                            <div>{cuttingJodiText}</div>
                        )}
                    </div> */}
                    <div className="cutting-jodi">
                        {cuttingJodiText && cuttingJodiText !== "no data above cutNum" ? (
                            <>
                                <div className="text-line">Above {cutNum} Cutting Jodi:</div>
                                <div className="blue-text">{cuttingJodiText}</div>
                                <button onClick={handleCopyJodi} className="copy-button">
                                    {copiedJodi ? "Copied!" : "Copy"}
                                </button>
                            </>
                        ) : (
                            <div className="no-data-text">{cuttingJodiText}</div>
                        )}
                    </div>
                    <div className='cutting-haroof'>

                        <div className='cutting-haroof-andar'>
                            {cuttingHaroofTextAndar && cuttingHaroofTextAndar !== "no data above cutHrf" ? (
                                <>
                                    <div className="text-line">Above {cutHrf || 0} Cutting Haroof Andar:</div>
                                    <div className="blue-text" style={{ marginTop: "5px" }}>{cuttingHaroofTextAndar}</div>
                                    <button
                                        onClick={handleCopyHaroofAndar}
                                        className="copy-button"
                                        style={{ marginTop: "8px" }}
                                    >
                                        {copiedHaroofAndar ? "Copied!" : "Copy"}
                                    </button>
                                </>
                            ) : (
                                <div className="no-data-text">{cuttingHaroofTextAndar}</div>
                            )}
                        </div>
                        <div className='cutting-haroof-bahar'>
                            {cuttingHaroofTextBahar && cuttingHaroofTextBahar !== "no data above cutHrf" ? (
                                <>
                                    <div className="text-line">Above {cutHrf || 0} Cutting Haroof Bahar:</div>
                                    <div className="blue-text" style={{ marginTop: "5px" }}>{cuttingHaroofTextBahar}</div>
                                    <button
                                        onClick={handleCopyHaroofBahar}
                                        className="copy-button"
                                        style={{ marginTop: "8px" }}
                                    >
                                        {copiedHaroofBahar ? "Copied!" : "Copy"}
                                    </button>
                                </>
                            ) : (
                                <div className="no-data-text">{cuttingHaroofTextBahar}</div>
                            )}

                        </div>
                    </div>

                </div >

            </div >
        </>
    );
}
